import type { SponsoredContentLoadedAction } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { SponsoredContent } from '@web-platform/shared-universal-types/src/redux/state/entities/sponsoredContent';

export const SPONSORED_CONTENT_LOADED = 'SPONSORED_CONTENT_LOADED';

export function sponsoredContentLoaded(
  sponsoredContent: SponsoredContent,
): SponsoredContentLoadedAction {
  return {
    type: SPONSORED_CONTENT_LOADED,
    payload: {
      sponsoredContent,
    },
  };
}
